import { encodePathSegments } from '../../../utils/media-url';

// Rótulos/formatação do catálogo unificado de Item (produto+serviço) -
// mesma convenção de servicoUtils.js/ticketUtils.js.
export const TIPO_COBRANCA_LABELS = {
    avulso: 'Avulso',
    recorrente: 'Recorrente'
};

export const RECORRENCIA_PERIODO_LABELS = {
    dias: 'dias',
    semanas: 'semanas',
    meses: 'meses'
};

export const recorrenciaResumo = (detalhe) => {
    if (!detalhe || detalhe.tipo_cobranca !== 'recorrente') return TIPO_COBRANCA_LABELS.avulso;
    if (!detalhe.recorrencia_intervalo || !detalhe.recorrencia_periodo) return TIPO_COBRANCA_LABELS.recorrente;
    return `A cada ${detalhe.recorrencia_intervalo} ${RECORRENCIA_PERIODO_LABELS[detalhe.recorrencia_periodo] || detalhe.recorrencia_periodo}`;
};

const BACKEND_SERVER = process.env.REACT_APP_BACKEND_SERVER || 'http://127.0.0.1:8000/api/';

// Monta a URL absoluta de um arquivo privado (imagem de item, anexo de
// serviço) guardado no R2 - mesmo proxy (`get_image`) já usado em
// DadosDealDrawer.js/TicketDetailDrawer.js. Espera um `path` relativo (ex:
// `Document.r2_key`, `ItemListSerializer.imagem_capa` - que usa `.name`
// de propósito). Alguns campos (ex: `Item.imagem`/`ItemProdutoImagem.imagem`
// no serializer de detalhe) são `ImageField` puro e o DRF serializa como
// `.url` - já uma URL pública completa (bucket com `AWS_QUERYSTRING_AUTH=False`),
// não uma key - passá-la pro proxy quebrava (`/media/https://...`). Repassa
// direto quando já vier absoluta, em vez de embrulhar de novo.
export const mediaUrl = (appId, path) => {
    if (!path || !appId) return '';
    if (/^https?:\/\//i.test(path)) return path;
    return `${BACKEND_SERVER}v1/apps/${appId}/media/${encodePathSegments(path)}`;
};

// "R$ X" pra serviço, "A partir de R$ X" pra produto com variações,
// "Sob consulta" quando não há preço nenhum ainda.
export const precoResumo = (it) => {
    const formatar = (v) =>
        Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    if (it.tipo === 'servico') {
        return it.preco !== null && it.preco !== undefined ? formatar(it.preco) : 'Sob consulta';
    }
    if (it.preco_a_partir_de !== null && it.preco_a_partir_de !== undefined) {
        return `A partir de ${formatar(it.preco_a_partir_de)}`;
    }
    return 'Sob consulta';
};
